import { useFormikContext } from "formik";
import React, { FC, useEffect, useState } from "react";
import { FILTER_SITES } from "../../constants/filter-types";
import { useLocale } from "../../contexts/localeContext";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import { getSites } from "../../services/siteService";

interface WizardSummaryProps {
    onNext?: (event: any) => void | undefined;
    onBack?: (event: any) => void | undefined;
}

export const WizardSummary: FC<WizardSummaryProps> = ({ onNext = undefined, onBack = undefined }) => {
    const { translate } = useLocale();
    const { values } = useFormikContext<any>();
    const [summaryTitle, setSummaryTitle] = useState('');
    const [summaryContent, setSummaryContent] = useState('');

    useEffect(() => {
        const selectedFilterType = values.type;
        generateSummaryTitle(selectedFilterType);
        generateSummaryContent(selectedFilterType);
    }, [values.type, values.settingDatas])

    const generateSummaryTitle = (selectedFilterType: string) => {
        if (selectedFilterType === FILTER_SITES) {
            return setSummaryTitle(translate.byKey(TranslationKeys.sites));
        }
        return setSummaryTitle('')
    }

    const generateSummaryContent = async (selectedFilterType: string) => {
        const selectedFilterOptions = values.settingDatas
        let summaryContent = '';

        if (selectedFilterType === FILTER_SITES) {
            const sites = (await getSites()).rows;
            sites.filter((name) => {
                if (selectedFilterOptions.includes(name.id.toString())) {
                    summaryContent = summaryContent + (name.name) + ", ";
                }
            })
        }
        return setSummaryContent(summaryContent)
    }


    return <div className="flex flex-col pt-3 pr-3 h-full relative" style={{ height: "501px" }}>
        <div className="flex flex-row">
            <div className="flex flex-col flex-1">
                <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.dataFilters)}: <span className="text-sm text-black">{summaryTitle}</span></h4>
                <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.selectedFilters)}: <span className="text-sm text-black">{summaryContent}</span></h4>
            </div>
        </div>

        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row mt-4">
                <button
                    className={`secondary secondary-inverse py-1 px-5 ${onBack ? '' : 'invisible'}`}
                    type="button"
                    onClick={e => {
                        if (onBack)
                            onBack(e);
                    }}>{translate.byKey(TranslationKeys.back)}</button>
            </div>
            <div className="flex flex-row justify-end mt-4 pl-3">
                <button
                    className={`py-1 px-5 secondary secondary-enabled`}
                    type={false ? 'button' : 'submit'}
                    id="wizardSummarySubmitBtn"
                    onClick={onNext ? (e) => onNext(e) : () => { }}>{translate.byKey(TranslationKeys.confirm)}</button>
            </div>
        </div>
    </div>;
};
